/*
 * @Author: Yandong Hu
 * @github: https://github.com/Mad-hu
 * @Date: 2021-10-20 15:33:26
 * @LastEditTime: 2022-03-21 14:42:41
 * @LastEditors: Yandong Hu
 * @Description:
 */

import { Spin } from "antd";
import { useRecoilValue } from "recoil";
import {
  LoadingTextState,
  LoadingVisibleState,
} from "../../services/loading.service";
import "./loading-view.scss";

export const LoadingView = () => {
  const loadingVisibleState = useRecoilValue(LoadingVisibleState);
  const loadingTextState = useRecoilValue(LoadingTextState);
  return loadingVisibleState ? (
    <div className="loading-view">
      <div className="box">
        <Spin size="large" tip={loadingTextState} className="loading"></Spin>
      </div>
    </div>
  ) : null;
};
